import { SignUpFlowActionTypes, SignUpFlowState } from './types';

const initialState: SignUpFlowState = {
    openModal: false,
    tasks: [],
};

export function signUpFlowReducer(
    state = initialState,
    action: SignUpFlowActionTypes,
): SignUpFlowState {
    switch (action.type) {
        case 'SET_SIGN_UP_FLOW_TASKS':
            return {
                ...state,
                tasks: action.payload,
            };

        case 'UPDATE_TASK':
            return {
                ...state,
                tasks: state.tasks.map((task) => {
                    if (task.identifier === action.payload.type) {
                        task.completed = action.payload.completed;
                    }
                    return task;
                }),
            };

        case 'SET_SIGN_UP_FLOW_MODAL':
            return {
                ...state,
                openModal: action.payload,
            };

        default:
            return state;
    }
}
